import { FC } from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import ClientOnly from "components/ClientOnly";
import InfoBox from "components/InfoBox";
import { INFO_BOX_TYPE } from "components/InfoBox/types";

import styles from "./styles";

interface SectionDescriptionProps {
  html: string;
  isMinted?: boolean;
  isMintGated?: boolean;
  mintGatedText?: string;
}

const SectionDescription: FC<SectionDescriptionProps> = ({
  html,
  isMinted,
  isMintGated,
  mintGatedText,
}) => {
  if (!isMinted && isMintGated) {
    return (
      <Box display="grid" gap={4}>
        <InfoBox type={INFO_BOX_TYPE.INFO}>{mintGatedText}</InfoBox>
      </Box>
    );
  }
  return (
    <Box display="grid" gap={4}>
      <ClientOnly>
        <Typography component="div" sx={styles.text}>
          <div
            dangerouslySetInnerHTML={{
              __html: html,
            }}
          />
        </Typography>
      </ClientOnly>
    </Box>
  );
};

export default SectionDescription;
